import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

/**
 * useLandingLeadForms — state + submit handlers for the two landing-page lead forms
 * (general contact + in-person NJ inquiry). Extracted from Landing so the page is
 * presentational. Behavior unchanged.
 */
export function useLandingLeadForms() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const [njForm, setNjForm] = useState({ name: "", email: "", phone: "", zip: "", experience: "", message: "" });
  const [njSubmitting, setNjSubmitting] = useState(false);

  const submitLead = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) return toast.error("Name and email required");
    setSubmitting(true);
    try {
      await api.post("/leads/public", { ...form, source: "Landing Page" });
      toast.success("Message received. Coach Chris will be in touch.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Failed to submit");
    } finally {
      setSubmitting(false);
    }
  };

  const submitInPerson = async (e) => {
    e.preventDefault();
    if (!njForm.name || !njForm.email || !njForm.phone || !njForm.zip || !njForm.experience) {
      return toast.error("Name, email, phone, zip, and experience level are required");
    }
    if (njForm.phone.replace(/\D/g, "").length < 7) {
      return toast.error("Please enter a valid phone number");
    }
    setNjSubmitting(true);
    try {
      const composedMessage = [
        `Zip: ${njForm.zip}`,
        `Experience: ${njForm.experience}`,
        njForm.message ? `\nLooking for:\n${njForm.message}` : "",
      ].filter(Boolean).join(" · ").replace(" · \n", "\n");
      await api.post("/leads/public", {
        name: njForm.name,
        email: njForm.email,
        phone: njForm.phone,
        source: "In-Person Training (NJ)",
        message: composedMessage,
      });
      toast.success("Thanks! Coach Chris will reach out about in-person training in NJ.");
      setNjForm({ name: "", email: "", phone: "", zip: "", experience: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Failed to submit");
    } finally {
      setNjSubmitting(false);
    }
  };

  return { form, setForm, submitting, submitLead, njForm, setNjForm, njSubmitting, submitInPerson };
}
